// RBAC permission ids (DimPermission.PermissionId). Access checks use ids, never names.
// Keep in sync with the backend PERMISSION_* settings.
export const MANAGE_USERS_PERMISSION_ID = 16
export const SEMANTICMODELS_MANAGE_PERMISSION_ID = 34
export const ANALYTICS_QUERY_PERMISSION_ID = 35
// Per-company chat access (roles GailsBasicUser / TBFBasicUser).
export const CHAT_GAILS_PERMISSION_ID = 46
export const CHAT_TBF_PERMISSION_ID = 47
// Per-company analytics access (roles GailsAnalyticsUser / TBFAnalyticsUser).
export const ANALYTICS_GAILS_PERMISSION_ID = 36
export const ANALYTICS_TBF_PERMISSION_ID = 37

export const hasPermission = (
  permissionIds: number[] | undefined,
  permissionId: number,
): boolean => (permissionIds || []).includes(permissionId)
